"use client"

import React from "react"
import {
  MessageList,
  MessageInput,
  Thread,
  useChannelStateContext,
  MessageRenderer,
  defaultRenderMessages,
} from "stream-chat-react"
import { MessagingChannelHeader } from "./MessagingChannelHeader"
import { ampli } from "@/ampli"
import { ChatWarningText } from "./ChatWarningText"
import { decodeGraphqlNodeId } from "@/tracking"
import { useSession } from "@/hooks/useSession"

export type ChannelInnerProps = {}

export const ChannelInner: React.FC<ChannelInnerProps> = ({}) => {
  const { channel } = useChannelStateContext()
  const session = useSession()

  const sessionUuid = session?.data?.user?.uuid

  const actions = ["delete", "edit", "flag", "markUnread", "mute", "react", "reply"]

  const members = Object.values(channel.state.members || {}).filter(member => member.user?.id !== sessionUuid)

  const handleOverrideSubmit = async (message: any, channelCid: string) => {
    ampli.chatMessageSend({
      chat_type: channel.type,
      user_id: members.map(member => decodeGraphqlNodeId(member?.user?.relay_id as string).numericalId || ""),
    })

    await channel.sendMessage(message)
  }

  const customRenderMessages: MessageRenderer = options => {
    const elements = defaultRenderMessages(options)
    elements.unshift(<ChatWarningText />)
    return elements
  }

  return (
    <div className="relative flex h-dvh w-screen flex-1 flex-col overflow-hidden sm:w-full">
      <MessagingChannelHeader />
      <div className="flex flex-1 flex-col overflow-hidden">
        <MessageList messageActions={actions} renderMessages={customRenderMessages} />
      </div>
      <div className="flex w-screen flex-shrink-0 flex-col border-t border-bg-3 sm:w-full">
        <MessageInput
          focus={false}
          overrideSubmitHandler={handleOverrideSubmit}
          audioRecordingEnabled
          asyncMessagesMultiSendEnabled
          grow={true}
        />
      </div>
      <Thread />
    </div>
  )
}
